import React, {useEffect, useMemo, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import Papa from 'papaparse'
import {read, utils, writeFile, readFile} from 'xlsx'
import UploadListMapping from './UploadContactList/UploadListMapping'
import {FileUploader} from 'react-drag-drop-files'
import {isMobileValidate} from '../../../../../Utils/_helpers/ValidationSchema'
import axios from 'axios'
import {
  StoreReportData,
  removeCount,
} from '../../../Contacts/AllContactsList/SubscriberSlice/SubscriberSlice'
import UploadContactByCopyPast from './CopyPastNumberList/UploadContactByCopyPast'
import CreateSegmentPopup from '../../../Contacts/Segments/Modal/CreateSegmentPopup'
import Select from 'react-select'
import {FindUniqArr} from '../../../../../Utils/AllHelperFunctions'
import {
  BulkMessageReview,
  BulkMsgDraftData,
  getReviewData,
  getTotalCount,
  getTotalCounts,
} from '../../BulkMessageSlice/BulkMessageSlice'
import {useLocation} from 'react-router-dom'
import {KTSVG} from '../../../../../../_metronic/helpers'
import Dropzone from 'react-dropzone'
import {Col, Form, OverlayTrigger, Tooltip} from 'react-bootstrap'
import { getIsDefaultRegion } from '../../../accounts/Overview/OverviewSlice/UserDetailsSlice'

const BulkMessageSendTo = ({
  setBulkMessageData,
  bulkMessageData,
  setContectListModel,
  setSegmentContectListModel,
  SecondDiv,
  segmentAndTags,
  checkStep,
  errordata,
  setErrorData,
  setCheckStep,
  validation,
}: any) => {
  const acceptedFileTypes = {
    'text/csv': ['.csv'],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx', '.xls'],
  }
  const param: any = useLocation()
  const dispatch = useDispatch()
  const countOfsegment: any[] = useSelector((state: any) => state?.SegmentData?.counts?.data)
  const [mappingPopup, setMappingPopup] = useState(false)
  const [csvdata, setCsvdata] = useState<any>([])

  const totalContat: any = useSelector(getTotalCount)
  const totalContatcs: any = useSelector(getTotalCounts)
  const isDefaultRegion = useSelector(getIsDefaultRegion)

  const uploadCount = useSelector((state: any) => state?.subscriberData?.uploadataCount)

  const [error, setError] = useState({upload: '', copybyNumber: '', copybyDetails: ''})
  const [mapped, setMapped] = useState<any>([])
  const [segmentData, setSegmentData] = useState<any>({})
  const [createSegment, setCreateSegment] = useState(false)
  const [finalData, setFinalData] = useState<any>({
    name: '',
    file: '',
    mergeLabels: '',
    tagIds: '',
  })

  const [isToSelectTag, setIsToSelectTag] = useState(false)
  const tagOptions = segmentAndTags.filter((el: any) => el.label !== 'Segment')

  useEffect(() => {
    if (
      bulkMessageData?.to &&
      bulkMessageData?.to?.selectedType &&
      bulkMessageData?.to?.selectedType === 'segmentOrTags'
    ) {
      if (
        bulkMessageData?.to?.value &&
        Array.isArray(bulkMessageData?.to?.value) &&
        bulkMessageData?.to?.value.length > 0
      ) {
        const selectedItem = bulkMessageData?.to?.value[0] as String
        if (selectedItem.startsWith('tag_')) {
          setIsToSelectTag(true)
        }
      }
    }
  }, [bulkMessageData?.to])

  const handleChange = (e: any) => {
    e[0].arrayBuffer().then((res: any) => {
      let data = new Uint8Array(res)
      let workbook = read(data, {type: 'array'})
      let worksheet = workbook.Sheets[workbook.SheetNames[0]]
      let fdata = utils.sheet_to_csv(worksheet, {rawNumbers: true})
      Papa.parse(fdata, {
        complete: function (results: any) {
          let errorData = {...errordata}
          delete errorData.to
          setErrorData(errorData)
          setFinalData({...finalData, name: e?.[0]?.name, file: e[0]})
          setCsvdata(results.data)

          setMappingPopup(true)

          setError({upload: '', copybyDetails: '', copybyNumber: ''})
        },
      })
    })
  }

  // const listMapping = useMemo(
  //   () => (

  //   ),
  //   [mappingPopup, mapped, csvdata, finalData]
  // )
  const createSegmentPopup = useMemo(
    () => (
      <CreateSegmentPopup
        segmentData={segmentData}
        setSegmentData={setSegmentData}
        show={createSegment}
        handleClose={() => setCreateSegment(false)}
      />
    ),
    [createSegment]
  )

  const customcount = ['uploadList', 'segmentOrTags', 'all', 'copyPaste']
  return (
    <>
      <UploadListMapping
        finalData={finalData}
        setFinalData={setFinalData}
        data={csvdata}
        mapped={mapped}
        setMapped={setMapped}
        show={mappingPopup}
        handleClose={() => setMappingPopup(false)}
        setBulkMessageData={setBulkMessageData}
        bulkMessageData={bulkMessageData}
      />
      {createSegmentPopup}
      <h2
        className={`accordion-header ${
          bulkMessageData?.to?.selectedType !== '' &&
          bulkMessageData?.to?.value !== '' &&
          'successData'
        } ${bulkMessageData?.contacts?.length > 0 && 'successData'}`}
        id='headingTwo'
      >
        <button
          className='accordion-button collapsed'
          type='button'
          data-bs-toggle='collapse'
          data-bs-target={`#collapseTwo`}
          aria-expanded='false'
          aria-controls='collapseTwo'
        >
          To
        </button>
        <div className='bulk-message-collapse'>
          <div
            className={`accordion-title-detail small bm_to_count ${
              bulkMessageData?.to?.selectedType === 'all' ||
              bulkMessageData?.to?.selectedType === 'segmentOrTags'
                ? 'text-decoration-underline'
                : ''
            }`}
            onClick={() => {
              if (bulkMessageData?.to?.selectedType === 'all') {
                setContectListModel(true)
              }
              if (bulkMessageData?.to?.selectedType === 'segmentOrTags') {
                setSegmentContectListModel(true)
              }
            }}
            data-testid='txtTotalRecipients'
          >
            Total Recipients:{' '}
            <b>
              {bulkMessageData?.to?.selectedType === 'segmentOrTags' &&
                totalContat?.totalContactCount}
            </b>
            <b>{bulkMessageData?.to?.selectedType === 'all' && totalContat?.totalContactCount}</b>
            <b>
              {!customcount?.includes(bulkMessageData?.to?.selectedType) &&
                param?.state?.data?.length}
            </b>
            <b>
              {bulkMessageData?.to?.selectedType == 'uploadList' &&
                uploadCount !== undefined &&
                uploadCount?.totalContact}
            </b>
            <b>
              {bulkMessageData?.to?.selectedType == 'copyPaste' &&
                uploadCount !== undefined &&
                uploadCount?.totalContact}
            </b>
            {bulkMessageData?.to?.selectedType === 'all' ||
            bulkMessageData?.to?.selectedType === 'segmentOrTags' ? (
              <i className='bi bi-box-arrow-up-right mx-2'></i>
            ) : null}
          </div>

          {/* <button
            type='button'
            className=' btn-toggle-bulk'
            data-bs-toggle='collapse'
            data-bs-target={`#collapseTwo`}
            aria-expanded='false'
            aria-controls='collapseTwo'
          >
            Click
          </button> */}
        </div>
      </h2>

      <div
        id='collapseTwo'
        className={`accordion-collapse collapse  ${checkStep.to && 'show'}`}
        aria-labelledby='headingTwo'
        data-bs-parent='#accordionExample'
      >
        <div className='accordion-body'>
          <ul className='nav nav-tabs' id='myTab' role='tablist'>
            <OverlayTrigger
              placement='top'
              overlay={
                <Tooltip id='button-tooltip'>
                  This will select all contacts within all lists{' '}
                  <strong>| Total Recipients: {totalContatcs}</strong>
                </Tooltip>
              }
            >
              <li className='nav-item me-3 mb-3' role='presentation'>
                <button
                  className={`nav-link btn btn-outline btn-outline-dashed btn-outline-default w-100 p-4 px-6 ${
                    bulkMessageData?.to?.selectedType == 'all' && 'active'
                  }`}
                  id='All-contact-tab'
                  data-bs-toggle='tab'
                  data-bs-target='#allcontact'
                  type='button'
                  role='tab'
                  aria-controls='All Contact'
                  aria-selected='true'
                  onClick={() => {
                    dispatch(removeCount())
                    let errorData = {...errordata}
                    delete errorData.to
                    setBulkMessageData({
                      ...bulkMessageData,
                      to: {
                        selectedType: 'all',
                        value: 'all',
                      },
                      contacts: [],
                    })
                    dispatch(
                      BulkMsgDraftData({
                        ...bulkMessageData,
                        scheduledAt: '',
                        to: {
                          selectedType: 'all',
                          value: 'all',
                        },
                        contacts: [],
                      })
                    )
                    setErrorData(errorData)
                  }}
                >
                  All Contacts
                </button>
              </li>
            </OverlayTrigger>
            <OverlayTrigger
              placement='top'
              overlay={
                <Tooltip id='button-tooltip'>
                  {isDefaultRegion ? 'Lists which have already been created in List, Segments & Tags' : 'Lists which have already been created in Tags'}
                </Tooltip>
              }
            >
              <li className='nav-item me-3 mb-3' role='presentation'>
                <button
                  className={`nav-link btn btn-outline btn-outline-dashed btn-outline-default w-100 p-4 px-6 ${
                    bulkMessageData?.to?.selectedType == 'segmentOrTags' && 'active'
                  }`}
                  id='Segment-tags-tab'
                  data-bs-toggle='tab'
                  data-bs-target='#Segmenttags'
                  type='button'
                  role='tab'
                  aria-controls='Segment-tags'
                  aria-selected='false'
                  onClick={() => {
                    setBulkMessageData({
                      ...bulkMessageData,
                      to: {
                        selectedType: 'segmentOrTags',
                        value: '',
                      },
                      contacts: [],
                    })
                    dispatch(
                      BulkMsgDraftData({
                        ...bulkMessageData,
                        scheduledAt: '',
                        to: {
                          selectedType: 'segmentOrTags',
                          value: '',
                        },
                        contacts: [],
                      })
                    )
                    dispatch(removeCount())
                  }}
                >
                  {isDefaultRegion ? 'List, Segments & Tags' : 'Tags'}
                </button>
              </li>
            </OverlayTrigger>
            <OverlayTrigger
              placement='top'
              overlay={<Tooltip id='button-tooltip'>Upload a new list from a file</Tooltip>}
            >
              <li className='nav-item me-3 mb-3' role='presentation'>
                <button
                  className={`nav-link btn btn-outline btn-outline-dashed btn-outline-default w-100 p-4 px-6 ${
                    bulkMessageData?.to?.selectedType == 'uploadList' && 'active'
                  }`}
                  id='Upload-list-tab'
                  data-bs-toggle='tab'
                  data-bs-target='#Upload-list'
                  type='button'
                  role='tab'
                  aria-controls='Upload-list'
                  aria-selected='false'
                  onClick={() => {
                    setBulkMessageData({
                      ...bulkMessageData,
                      to: {
                        selectedType: 'uploadList',
                        value: '',
                      },
                      contacts: [],
                    })
                    dispatch(
                      BulkMsgDraftData({
                        ...bulkMessageData,
                        scheduledAt: '',
                        to: {
                          selectedType: 'uploadList',
                          value: '',
                        },
                        contacts: [],
                      })
                    )
                    dispatch(removeCount())
                  }}
                >
                  Upload list
                </button>
              </li>
            </OverlayTrigger>
            <OverlayTrigger
              placement='top'
              overlay={
                <Tooltip id='button-tooltip'>
                  Paste your client data in without creating a list. Follow format and sequence as
                  outlined below, each subscriber to fall on a new line.
                </Tooltip>
              }
            >
              <li className='nav-item me-3 mb-3' role='presentation'>
                <button
                  className={`nav-link btn btn-outline btn-outline-dashed btn-outline-default w-100 p-4 px-6 ${
                    bulkMessageData?.to?.selectedType == 'copyPaste' && 'active'
                  }`}
                  id='copy-paste-tab'
                  data-bs-toggle='tab'
                  data-bs-target='#copy-paste'
                  type='button'
                  role='tab'
                  aria-controls='copy-paste'
                  aria-selected='false'
                  onClick={() => {
                    setBulkMessageData({
                      ...bulkMessageData,
                      to: {
                        selectedType: 'copyPaste',
                        value: '',
                      },
                      contacts: [],
                    })
                    dispatch(
                      BulkMsgDraftData({
                        ...bulkMessageData,
                        scheduledAt: '',
                        to: {
                          selectedType: 'copyPaste',
                          value: '',
                        },
                        contacts: [],
                      })
                    )
                    dispatch(removeCount())
                  }}
                >
                  Copy & Paste
                </button>
              </li>
            </OverlayTrigger>
          </ul>
          <div className='tab-content' id='myTabContent'>
            <div
              className={`tab-pane fade ${
                bulkMessageData?.to?.selectedType === 'all' && 'show active'
              }`}
              id='allcontact'
              role='tabpanel'
              aria-labelledby='All-contact-tab'
            >
              <span
              data-testid='txtTotalRecipients'
              >
                Total Recipients:{' '}
                <b>
                  {bulkMessageData?.to?.selectedType === 'segmentOrTags' &&
                    totalContat?.totalContactCount}
                </b>
                <b>
                  {bulkMessageData?.to?.selectedType === 'all' && totalContat?.totalContactCount}
                </b>
                <b>
                  {!customcount?.includes(bulkMessageData?.to?.selectedType) &&
                    param?.state?.data?.length}
                </b>
                <b>
                  {bulkMessageData?.to?.selectedType == 'uploadList' &&
                    uploadCount !== undefined &&
                    uploadCount?.totalContact}
                </b>
                <b>
                  {bulkMessageData?.to?.selectedType == 'copyPaste' &&
                    uploadCount !== undefined &&
                    uploadCount?.totalContact}
                </b>
              </span>
            </div>

            <div
              className={`tab-pane fade ${
                bulkMessageData?.to?.selectedType === 'segmentOrTags' && 'show active'
              }`}
              id='Segmenttags'
              role='tabpanel'
              aria-labelledby='Segment-tags-tab'
            >
              <label className='mb-0' data-testid='labelSegment&Tags'>{isDefaultRegion ? 'Segments & Tags' : 'Tags'}</label>
              <div className='d-flex align-items-center flex-column flex-sm-row'>
                <Select
                  className='form-select bg-light-primary border-0 mw-xl-75 py-4'
                  data-testid='ddSegment&Tags'
                  value={FindUniqArr(segmentAndTags, bulkMessageData?.to?.value)}
                  isMulti
                  options={segmentAndTags}
                  onChange={async (e: any) => {
                    let errorData = {...errordata}
                    delete errorData.to

                    let data = []
                    if (Array.isArray(e) && e.length > 0) {
                      const newValue = e[e.length - 1]

                      if (newValue.group === 'segment') {
                        data = [newValue.value]
                      }

                      if (newValue.group === 'tag' || newValue.group === 'list') {
                        setIsToSelectTag(true)
                        let tagValues = e.filter(
                          (el: any) => el.group === 'tag' || el.group === 'list'
                        )
                        data = tagValues.map((key: any) => key.value)
                      } else {
                        setIsToSelectTag(false)
                      }
                    } else {
                      setIsToSelectTag(false)
                    }

                    setBulkMessageData({
                      ...bulkMessageData,
                      to: {
                        ...bulkMessageData.to,
                        selectedType: 'segmentOrTags',
                        value: data,
                      },
                    })
                    dispatch(
                      BulkMsgDraftData({
                        ...bulkMessageData,
                        scheduledAt: '',
                        to: {
                          ...bulkMessageData.to,
                          selectedType: 'segmentOrTags',
                          value: data,
                        },
                      })
                    )
                    setErrorData(errorData)
                  }}
                />

              {isDefaultRegion && (
                <button
                  onClick={() => setCreateSegment(true)}
                  data-testid="btnAddNewSegmet"
                  className="btn btn-primary msg-primary-btn text-nowrap p-4 px-7 m-2 ms-4"
                >
                  + New Segment
                </button>
              )}
              </div>
              {(isToSelectTag && isDefaultRegion) && (
                <Form.Group className='mt-5'>
                  <Col>
                    <Form.Check
                      type='switch'
                      id='isExclude'
                      label='Do not send to lists or tags (optional)'
                      checked={
                        bulkMessageData?.to?.exclude && bulkMessageData?.to?.exclude === true
                          ? true
                          : false
                      }
                      onChange={(e) => {
                        setBulkMessageData({
                          ...bulkMessageData,
                          to: {
                            ...bulkMessageData.to,
                            exclude:
                              bulkMessageData?.to?.exclude && bulkMessageData?.to?.exclude === true
                                ? false
                                : true,
                          },
                        })
                        dispatch(
                          BulkMsgDraftData({
                            ...bulkMessageData,
                            to: {
                              ...bulkMessageData.to,
                              exclude:
                                bulkMessageData?.to?.exclude &&
                                bulkMessageData?.to?.exclude === true
                                  ? false
                                  : true,
                            },
                          })
                        )
                      }}
                      name='isSharingCredit'
                      className={`${!bulkMessageData?.to?.exclude && 'checkbox-custom'}`}
                    />
                  </Col>
                </Form.Group>
              )}

              {isToSelectTag && bulkMessageData?.to?.exclude === true && (
                <div className='d-flex align-items-center flex-column flex-sm-row'>
                  <Select
                    className='form-select bg-light-primary border-0 mw-xl-75 py-4'
                    value={FindUniqArr(segmentAndTags, bulkMessageData?.to?.excludeTags)}
                    isMulti
                    options={tagOptions}
                    onChange={async (e: any) => {
                      let data = []
                      if (Array.isArray(e) && e.length > 0) {
                        const newValue = e[e.length - 1]
                        if (newValue.group === 'tag' || newValue.group === 'list') {
                          setIsToSelectTag(true)
                          let tagValues = e.filter(
                            (el: any) => el.group === 'tag' || el.group === 'list'
                          )
                          data = tagValues.map((key: any) => key.value)
                        } else {
                          setIsToSelectTag(false)
                        }
                      } else {
                        setIsToSelectTag(false)
                      }

                      setBulkMessageData({
                        ...bulkMessageData,
                        to: {
                          ...bulkMessageData.to,
                          excludeTags: data,
                        },
                      })
                      dispatch(
                        BulkMsgDraftData({
                          ...bulkMessageData,
                          scheduledAt: '',
                          to: {
                            ...bulkMessageData.to,
                            excludeTags: data,
                          },
                        })
                      )
                    }}
                  />
                </div>
              )}
            </div>

            <div
              className={`tab-pane fade File_upload_parent ${
                bulkMessageData?.to?.selectedType === 'uploadList' && 'show active'
              }`}
              id='Upload-list'
              role='tabpanel'
              aria-labelledby='Upload-list-tab'
            >
              {finalData?.name !== '' ? (
                <>
                  <section className='dragAndDrop'>
                    <div className='removeFile'>
                      <span className='fs-10'> {finalData?.name}</span>

                      <KTSVG
                        onClick={() => {
                          setCsvdata([])
                          setFinalData({
                            name: '',
                            file: '',
                            mergeLabels: '',
                            tagIds: '',
                          })
                        }}
                        path='/media/misc/cross-square.svg'
                        className='svg-icon  reomveIcon'
                      />
                    </div>
                  </section>
                </>
              ) : (
                <Dropzone accept={acceptedFileTypes} onDrop={handleChange}>
                  {({getRootProps, getInputProps}) => (
                    <section className='dragAndDrop'>
                      <KTSVG path={'/media/svg/dragandDrop.svg'} className='svg-icon-3x me-3' />
                      <div {...getRootProps()}>
                        <input {...getInputProps()} />
                        <span className='fs-7 d-block fw-boldest'>
                          Drop files here or click to upload
                        </span>
                        <span className='text-muted fs-7'>csv,xlsx</span>
                      </div>
                    </section>
                  )}
                </Dropzone>
              )}

              <div className='upload-list mt-3'>
                <span className='text-muted fs-7'>
                  Acceptable file Types: CSV, Text or Excel.
                  <a href='https://cellcast-profile-image.s3.ap-southeast-2.amazonaws.com/utils/sample_contacts.csv'>
                    {' '}
                    Download example Csv
                  </a>
                </span>
                {/* <label>

                  <input accept='.csv,.xlsx' type='file' name='file' onChange={handleChange} />
                  <img src='/Cellcast-reactjs/media/mobile/upload-doc.svg' alt='Upload' />
                  <div>
                    <span>Drop files here or click to upload</span>
                    <span title='types: csv,xlsx' className='file-types'>
                      .csv or .xlsx
                    </span>
                  </div>
                </label> */}
              </div>
            </div>

            <div
              className={`tab-pane fade ${
                bulkMessageData?.to?.selectedType === 'copyPaste' && 'show active'
              }`}
              id='copy-paste'
              role='tabpanel'
              aria-labelledby='copy-paste-tab'
            >
              <UploadContactByCopyPast
                error={errordata}
                setError={setErrorData}
                setBulkMessageData={setBulkMessageData}
                bulkMessageData={bulkMessageData}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default BulkMessageSendTo
